import React from 'react';
import { Button } from 'porosys-ui';
import './styles.scss';
import FormHeader from '../FormHeader/FormHeader';

const MainForm = props => {
    const { children, handleCancel, handleSubmit, formTitle } = props;

    return (
        <div>
            <div>
                <FormHeader
                    formTitle={formTitle}
                    handleCloseForm={
                        handleCancel &&
                        (() => {
                            handleCancel();
                        })
                    }
                />
                <form className="main-form" onSubmit={handleSubmit}>
                    {children}
                    <div className="form-btn">
                        <Button color="primary" type="submit">
                            ثبت
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default MainForm;
